import styles from './styles.module.css'
import React from 'react'

export const propertyLinks = (
  <ul className={styles.listDocumentation}>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/getting-started-with-property-data'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Property API starting guide
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/property-data-schema'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Property data schema
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/constructing-property-queries'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Constructing advanced queries
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/use-cases-for-property-data'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Specific use case guides
      </a>
    </li>
  </ul>
)

export const businessLinks = (
  <ul className={styles.listDocumentation}>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/getting-started-with-business-data'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Business API starting guide
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/business-data-schema'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Business data schema
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/constructing-business-queries'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Constructing advanced queries
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/business-data-use-cases'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Specific use case guides
      </a>
    </li>
  </ul>
)

export const peopleLinks = (
  <ul className={styles.listDocumentation}>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/getting-started-with-people-data'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        People API starting guide
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/people-data-schema'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        People data schema
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/constructing-people-queries'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Constructing advanced queries
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/use-cases-for-people-data'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Specific use case guides
      </a>
    </li>
  </ul>
)

export const productLinks = (
  <ul className={styles.listDocumentation}>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/getting-started-with-product-data-1'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Product API starting guide
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/product-data-schema'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Product data schema
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/constructing-product-queries'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Constructing advanced queries
      </a>
    </li>
    <li className={styles.liList}>
      <a
        href='https://docs.datafiniti.co/docs/use-cases-for-product-data'
        className={styles.linkList}
        target='_blank'
        rel='noopener noreferrer'
      >
        Specific use case guides
      </a>
    </li>
  </ul>
)
